{
  "app.name": "Soleil",
  "app.by": "par ArchiSimple",
  "language.label": "Langue",
  "common.back": "Retour",
  "common.close": "Fermer",
  "common.done": "OK",
  "welcome.title": "Voir la course du soleil, là où vous êtes",
  "welcome.intro": "Levez votre téléphone vers le ciel : la trajectoire du soleil se dessine sur l'image de la caméra, pour n'importe quel jour de l'année.",
  "welcome.needs": "Ce dont l'application a besoin",
  "welcome.camera": "Caméra",
  "welcome.cameraWhy": "Pour dessiner la trajectoire sur ce que vous voyez. Aucune image ne quitte le téléphone.",
  "welcome.location": "Position",
  "welcome.locationWhy": "Pour calculer où est le soleil ici. Vous pouvez aussi chercher une adresse.",
  "welcome.motion": "Mouvement et orientation",
  "welcome.motionWhy": "Pour savoir où pointe le téléphone : boussole et inclinaison.",
  "welcome.privacy": "Tout est calculé sur votre téléphone. Rien n'est envoyé ni enregistré, sauf les mots d'une adresse que vous cherchez.",
  "welcome.start": "Commencer",
  "welcome.manual": "Choisir un lieu sans GPS",
  "welcome.insecure": "Cette page doit être ouverte en HTTPS : les navigateurs ne donnent la caméra et les capteurs qu'à une page sécurisée.",
  "motion.title": "Autoriser l'accès aux mouvements",
  "motion.body": "Sur iPhone, Safari demande votre accord avant de donner la boussole et l'inclinaison du téléphone. Sans elles, la trajectoire ne suit pas vos gestes.",
  "motion.preview": "Ce qui va s'afficher",
  "motion.prompt": "Safari va demander si ce site peut accéder aux mouvements et à l'orientation.",
  "motion.hint": "Touchez Autoriser dans la fenêtre de Safari. Vous pourrez changer d'avis dans Réglages › Safari.",
  "motion.continue": "Continuer",
  "motion.skip": "Continuer sans capteurs",
  "compass.chip": "Boussole · nord vrai · ±{degrees}°",
  "compass.chipSettling": "Boussole · nord vrai",
  "compass.chipPoor": "Boussole perturbée",
  "compass.open": "Régler la boussole",
  "compass.title": "Boussole",
  "compass.accuracy": "Précision",
  "compass.good": "Bonne · ±{degrees}°",
  "compass.fair": "Moyenne · ±{degrees}°",
  "compass.poor": "Faible",
  "compass.settling": "Mesure en cours…",
  "compass.trueNorth": "Nord vrai : la déclinaison magnétique du lieu ({degrees}°) est corrigée automatiquement.",
  "compass.eightTitle": "La direction semble fausse ?",
  "compass.eightBody": "Éloignez-vous des objets métalliques, puis décrivez un 8 avec le téléphone pour réveiller la boussole.",
  "ar.horizon": "Horizon",
  "ar.sunrise": "Lever {time} · {degrees}°",
  "ar.sunset": "Coucher {time} · {degrees}°",
  "ar.sun": "Soleil",
  "ar.summary": "Résumé du jour",
  "ar.heading": "Le téléphone pointe à {degrees}°",
  "ar.direction": "Direction",
  "ar.height": "Hauteur",
  "ar.directionValue": "{degrees}° · {point}",
  "ar.above": "{degrees}° au-dessus de l'horizon",
  "ar.below": "{degrees}° sous l'horizon",
  "ar.now": "Maintenant",
  "ar.play": "Lire la journée",
  "ar.pause": "Pause",
  "ar.time": "Heure",
  "ar.hour": "{hour} h",
  "ar.highest": "{date} · le plus haut",
  "ar.lowest": "{date} · le plus bas",
  "ar.locating": "Recherche de votre position…",
  "ar.view": "La course du soleil sur l'image de la caméra",
  "point.north": "nord",
  "point.north-east": "nord-est",
  "point.east": "est",
  "point.south-east": "sud-est",
  "point.south": "sud",
  "point.south-west": "sud-ouest",
  "point.west": "ouest",
  "point.north-west": "nord-ouest",
  "cardinal.n": "N",
  "cardinal.e": "E",
  "cardinal.s": "S",
  "cardinal.w": "O",
  "date.title": "Date et heure",
  "date.open": "Changer la date",
  "date.days": "Jour de l'année",
  "date.date": "Date",
  "date.compare": "Afficher aussi l'équinoxe",
  "preset.today": "Aujourd'hui",
  "preset.spring": "Équinoxe de printemps",
  "preset.summer": "Solstice d'été",
  "preset.autumn": "Équinoxe d'automne",
  "preset.winter": "Solstice d'hiver",
  "zone.named": "Heure locale, {season} (UTC{offset}) · d'après votre téléphone",
  "zone.summer": "heure d'été",
  "zone.standard": "heure d'hiver",
  "zone.approximate": "Heure locale approximative (UTC{offset}) : aucun fuseau n'est connu pour un lieu saisi, l'heure est donc déduite de la longitude, sans heure d'été. La position du soleil à cette heure est exacte.",
  "summary.title": "Résumé du jour",
  "summary.sunrise": "Lever",
  "summary.noon": "Midi solaire",
  "summary.sunset": "Coucher",
  "summary.length": "Durée du jour",
  "summary.lengthValue": "{hours} h {minutes} min",
  "summary.longer": "{minutes, plural, one {# min de plus qu'hier} other {# min de plus qu'hier}}",
  "summary.shorter": "{minutes, plural, one {# min de moins qu'hier} other {# min de moins qu'hier}}",
  "summary.same": "Comme hier",
  "summary.polarDay": "Le soleil ne se couche pas",
  "summary.polarNight": "Le soleil ne se lève pas",
  "summary.today": "Ce jour",
  "summary.references": "Solstices et équinoxe",
  "summary.diagram": "Course du soleil vue du ciel : ce jour, et les solstices en pointillés",
  "summary.north": "Les directions sont données par rapport au nord géographique.",
  "summary.back": "Retour à la vue",
  "location.title": "Choisir un lieu",
  "location.mine": "Utiliser ma position",
  "location.search": "Adresse, ville, lieu ou coordonnées",
  "location.privacy": "Seul le texte tapé est envoyé au service d'adresses, à partir de 3 lettres. Rien d'autre ne quitte le téléphone.",
  "location.searching": "Recherche…",
  "location.none": "Aucun lieu trouvé. Essayez une ville, ou des coordonnées comme 48,8566 2,3522.",
  "location.failed": "Le service d'adresses ne répond pas. Saisissez plutôt des coordonnées, comme 48,8566 2,3522.",
  "location.results": "Suggestions",
  "location.typed": "Coordonnées saisies",
  "location.coordinates": "{latitude}°, {longitude}°",
  "location.chosen": "Lieu choisi",
  "location.credits": "Adresses : Base Adresse Nationale · © contributeurs OpenStreetMap (Photon)",
  "location.unavailable": "Votre position n'est pas disponible. Cherchez plutôt le lieu.",
  "location.use": "Utiliser ce lieu",
  "place.device": "Votre position",
  "place.manual": "Lieu choisi",
  "place.accuracy": "GPS ±{metres} m",
  "place.change": "Changer de lieu",
  "fallback.camera.title": "Caméra indisponible",
  "fallback.camera.body": "La trajectoire est dessinée sur un ciel neutre. Autorisez la caméra dans les réglages du navigateur pour la voir sur l'image réelle.",
  "fallback.sensors.title": "Pas de boussole sur cet appareil",
  "fallback.sensors.body": "Sur ordinateur, ou si l'accès aux mouvements est refusé, le ciel ne suit pas l'appareil : faites-le glisser.",
  "fallback.compass.title": "Boussole perturbée",
  "fallback.compass.body": "Un objet métallique ou un aimant fausse la direction. Éloignez-vous, puis décrivez un 8 avec le téléphone.",
  "fallback.retry": "Réessayer",
  "fallback.drag": "Faites glisser pour regarder autour de vous"
}
